<ng-template #signatureContent>
    <div class="signature-pad__content">
        <canvas
            #signatureCanvas
            class="signature-pad__canvas"
            width="1200"
            height="240"
            aria-label="Área para desenhar a assinatura"
            (pointerdown)="startDrawing($event)"
            (pointermove)="draw($event)"
            (pointerup)="stopDrawing($event)"
            (pointercancel)="stopDrawing($event)"
        ></canvas>

        <div class="signature-pad__buttons">
            <ui-button
                type="button"
                variant="outline"
                tooltip="Limpar assinatura"
                (click)="clearSignature()"
            >
                <i class="fa fa-eraser"></i>
            </ui-button>

            @if (showConfirm) {
                <ui-button
                    type="button"
                    tooltip="Confirmar assinatura"
                    (click)="confirmSignature()"
                >
                    <i class="fa fa-check"></i>
                </ui-button>
            }
        </div>
    </div>

    <span class="signature-pad__help">
        Utilize o mouse, uma caneta digital ou o dedo.
    </span>
</ng-template>

@if (showCard) {
    <ui-card [cardTitle]="title">
        <ng-container
            *ngTemplateOutlet="signatureContent"
        ></ng-container>
    </ui-card>
} @else {
    <ng-container
        *ngTemplateOutlet="signatureContent"
    ></ng-container>
}

@if (showOrientationWarning) {
    <div class="signature-pad__orientation-warning">
        <div class="signature-pad__phone-animation"></div>

        <p>
            Para assinar, por favor<br>
            <strong>gire seu dispositivo</strong>.
        </p>
    </div>
}
